// extracted by mini-css-extract-plugin
module.exports = {"efficience":"efficience-module--efficience--3e_-s","textWrapper":"efficience-module--textWrapper--2CGXC","imageWrapper":"efficience-module--imageWrapper--hCHVc"};